// PulseChain — pinned to the top of every network-filter dropdown
// (dashboard + Activity, extension + mobile-web builds).
export const PULSECHAIN_CHAIN_ID = 369n

/**
 * Returns a new array with PulseChain moved to the front, preserving the
 * relative order of every other network. No-op (returns the input) when
 * PulseChain is absent so callers can wrap unconditionally.
 */
export function sortNetworksPulseFirst<T extends { chainId: bigint }>(networks: T[]): T[] {
  const hasPulse = networks.some((n) => n.chainId === PULSECHAIN_CHAIN_ID)
  if (!hasPulse) return networks

  const pulse = networks.filter((n) => n.chainId === PULSECHAIN_CHAIN_ID)
  const rest = networks.filter((n) => n.chainId !== PULSECHAIN_CHAIN_ID)
  return [...pulse, ...rest]
}
